import { Fragment, useRef, useState, useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTheme } from '../../ThemeContext'; // Adjust the path as necessary
import AlertType from '../Dropdowns/AlertType'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ProjectNames from '../Dropdowns/ProjectNames'
import {addAlert, updateAlert} from '../../api/api'
export default function AddAlerts({
  setEditing,
  handlePageUpdate,
  isEditing,
  alertDetails,
}) {
  const { theme } = useTheme(); // Get the theme from context
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const [type, setType] = useState(isEditing ? alertDetails?.type || '' : '');
  const [pname, setPname] = useState(isEditing ? alertDetails?.projectId?._id || alertDetails?.projectId || '' : '');
  const [title, setTitle] = useState(isEditing ? alertDetails?.title || '' : '');
  const [date, setDate] = useState(isEditing ? alertDetails?.dateTime ? new Date(alertDetails.dateTime).toISOString().split('T')[0] : '' : '');
  const [time, setTime] = useState(isEditing ? alertDetails?.dateTime ? new Date(alertDetails.dateTime).toTimeString().slice(0, 5) : '' : '');
  const [text, setText] = useState(isEditing ? alertDetails?.description || '' : '');
  const [sendNotification, setSendNotification] = useState(true);
  const [scheduledDate, setScheduledDate] = useState(isEditing ? alertDetails?.scheduledDate ? new Date(alertDetails.scheduledDate).toISOString().slice(0, 16) : '' : '');
  const alertId = isEditing ? alertDetails?._id : null;
  const edit = isEditing;
  const onClose = () => {
    setOpen(false);
    if (edit) {
      setEditing(false);
    }
  };
  

  // Formik validation schema
  const validationSchema = Yup.object({
    project: Yup.string().required("Project is required"),
    name: Yup.string().required("Title is required"),
    text: Yup.string().required("text is required"),
    date: Yup.date().required("date is required"),
    time: Yup.date().required("time is required"),
  });

  // const formik = useFormik({
  //   initialValues: {
  //     project:pname,
  //     name: "",
  //     text: "",
  //     date: "",
  //     time: "",
  //   },
  //   validationSchema,
  //   onSubmit: async (values) => {
  //     const user = JSON.parse(localStorage.getItem("user"));
  //     const data = {
  //       project: values.project,
  //       title: values.name,
  //       text: values.text,
  //       date: values.date,
  //       time: values.time,
  //       type: type,
  //     };

  //     try {
  //       const res=addAlert(data)
  //       console.log(res)
  //       alert("Alert Added Successfully");
  //       setOpen(false); // Close the modal on success
  //       handlePageUpdate();
  //     } catch (error) {
  //       console.error("Something went wrong:", error);
  //     }
  //   },
  // });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
        projectId: pname,
        alert_type: type,
        alert_title: title,
        alert_date: date,
        alert_message: text,
        sendNotification: sendNotification,
        scheduledDate: scheduledDate || null,
    };

    try {
        if (edit && alertId) {
            await updateAlert({ id: alertId, data: formData });
            handlePageUpdate();
            onClose();
        } else {
            await addAlert(formData);
            handlePageUpdate();
            onClose();
        }
    } catch (error) {
        console.error("Error submitting alert:", error);
    }
};

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'} text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md`}
              >
                <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}>
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title as="h3" className="text-lg py-4 text-center font-semibold leading-6">
                        {isEditing ? 'Edit Alert' : 'Add Alerts'}
                      </Dialog.Title>
                      <form onSubmit={handleSubmit}>
                        <div className="grid gap-4 mb-4 sm:grid-cols-2">
                          

                          <div>
                            <div>
                            <ProjectNames pname={pname} handleChange={e => setPname(e.target.value)} />
                            </div>
                            
                            <label htmlFor="name" className="block mb-2 text-sm font-medium">Title</label>
                            <input
                              type="text"
                              name="title"
                              id="title"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter issue title"
                            />
                            {/* {formik.touched.name && formik.errors.name && (
                              <div className="text-red-600 text-sm">{formik.errors.name}</div>
                            )} */}
                          </div>

                          <div>
                            <AlertType type={type} handleChange={e => setType(e.target.value)} />
                          </div>

                         

                          <div>
                            <label htmlFor="date" className="block mb-2 text-sm font-medium">Date</label>
                            <input
                              type="date"
                              name="date"
                              id="date"
                              value={date}
                              onChange={(e) => setDate(e.target.value)}
                              onClick={(e) => e.target.showPicker()}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            />
                            {/* {formik.touched.date && formik.errors.date && (
                              <div className="text-red-600 text-sm">{formik.errors.date}</div>
                            )} */}
                          </div>
                          <div>
                            <label htmlFor="time" className="block mb-2 text-sm font-medium">Time</label>
                            <input
                              type="time"
                              name="time"
                              id="time"
                              value={time}
                              onChange={(e) => setTime(e.target.value)}
                              onClick={(e) => e.target.showPicker()}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            />
                            {/* {formik.touched.date && formik.errors.date && (
                              <div className="text-red-600 text-sm">{formik.errors.time}</div>
                            )} */}
                          </div>
                          <div className="col-span-2">
                            <label htmlFor="text" className="block mb-2 text-sm font-medium">Description</label>
                            <textarea
                              name="text"
                              id="text"
                              value={text}
                              onChange={(e) => setText(e.target.value)}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter detailed text"
                            />
                            {/* {formik.touched.text && formik.errors.text && (
                              <div className="text-red-600 text-sm">{formik.errors.text}</div>
                            )} */}
                          </div>

                          {/* Send Notification Toggle */}
                          <div className="col-span-2">
                            <label className="flex items-center gap-2 cursor-pointer">
                              <input
                                type="checkbox"
                                checked={sendNotification}
                                onChange={(e) => setSendNotification(e.target.checked)}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                              />
                              <span className="text-sm font-medium">Send notification to project team</span>
                            </label>
                          </div>

                          {/* Schedule Notification */}
                          {sendNotification && (
                            <div className="col-span-2">
                              <label htmlFor="scheduledDate" className="block mb-2 text-sm font-medium">Schedule Notification (optional)</label>
                              <input
                                type="datetime-local"
                                id="scheduledDate"
                                value={scheduledDate}
                                onChange={(e) => setScheduledDate(e.target.value)}
                                className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              />
                              <span className="text-xs text-gray-500">Leave empty to send immediately</span>
                            </div>
                          )}
                        </div>
                        <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between">
                          <button
                            type="submit"
                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto"
                          >
                            {isEditing ? 'Save' : 'Add'}
                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
                            onClick={() => {
                              setOpen(false);
                              { isEditing && setEditing(false) }
                            }}
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
